// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__3jkFt"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/InnerBanner/styles.css
// module id = 1497
// module chunks = 0